import { ScrollView, StyleSheet, Text, View } from 'react-native';
import React, { FC, useMemo } from 'react';
import { ClubServiceLayoutProps } from './ClubServiceLayout.types';
import PagePath from '../../components/PagePath';
import UserWebInfo from '../../components/UserWebInfo';
import { STYLE_VARS } from '../../constants/style-vars';
import Sidebar from '../../components/Sidebar';
import { Promotions } from '../../screens/Home/components/Promotions';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import { CLUB_SERVICES_TABS } from './ClubServiceLayout.constants';
import { NavigationService } from '../../services/navigation';

const ClubServiceLayout: FC<ClubServiceLayoutProps> = ({
  title,
  children,
  current = -1,
  icon,
  description,
}) => {
  const pathSteps = useMemo(() => {
    return [
      {
        name: 'Member area',
        onPress: () => {
          NavigationService.push('Root', {
            screen: 'HomeTab',
          });
        },
      },
      {
        name: 'Club Services',
      },
      {
        name: title,
      },
    ];
  }, [title]);
  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View
        style={{
          maxWidth: 1250,
          width: '90%',
          marginHorizontal: 'auto',
          marginTop: 10,
          minHeight: 500,
        }}
      >
        <PagePath pathSteps={pathSteps} />
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginVertical: 30,
          }}
        >
          <View style={{ width: '20%', minWidth: 230, marginRight: 20 }}>
            <UserWebInfo />
            <View
              style={{
                marginTop: 30,
                backgroundColor: STYLE_VARS.fccLightGrey,
              }}
            >
              <Sidebar data={CLUB_SERVICES_TABS} current={current} />
            </View>
            <Promotions />
          </View>
          <View style={{ width: '75%' }}>
            <PageTitle icon={icon} title={title} description={description} />
            {children}
          </View>
        </View>
      </View>
      <Footer />
    </ScrollView>
  );
};

export default ClubServiceLayout;

const styles = StyleSheet.create({});
